export const sessions = [
  {
    id: '1',
    tutorFirstName: 'Jenny',
    bio: 'Est leo posuere turpis, quis bibendum nisi magna',
    tutorLastName: 'W',
    tutorProgfileImg: '/images/offerings/jenny.png',
    imgUrl: '/images/offerings/session2.png',
    location: 'Location 1',
    title: 'Introduction to Trignometry',
    totalEnrolls: 1245,
    instruction:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
    tags: ['Virtual Individual Session'],
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
    price: 100,
    time: '1 Hour',
    isReviewing: true,
    bookingForm: 'BookingForm 1',
    studentName: 'John Deo',
    email: 'johndeo@gmail.com',
    number: '1234567890',
    studentDes:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
  },
  {
    id: '2',
    tutorFirstName: 'Eleanor',
    bio: 'Est leo posuere turpis, quis bibendum nisi magna',
    tutorLastName: 'P',
    tutorProgfileImg: '/images/offerings/eleanor.png',
    imgUrl: '/images/offerings/offerDetails.png',
    location: 'Location 2',
    title: 'Equations',
    totalEnrolls: 1245,
    instruction:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
    tags: ['Virtual Group Session'],
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
    price: 75,
    time: '1 Hour',
    isReviewing: false,
    bookingForm: 'BookingForm 1',
    studentName: 'John Deo',
    email: 'johndeo@gmail.com',
    number: '1234567890',
    studentDes:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
  },
  {
    id: '3',
    tutorFirstName: 'Savannah',
    bio: 'Est leo posuere turpis, quis bibendum nisi magna',
    tutorLastName: 'N',
    tutorProgfileImg: '/images/offerings/savannah.png',
    imgUrl: '/images/offerings/session1.png',
    location: 'Location 4',
    title: 'Integration',
    totalEnrolls: 145,
    instruction:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
    tags: ['In-Person Individual Session'],
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
    price: 300,
    time: '1 Hour',
    isReviewing: false,
    bookingForm: 'BookingForm 1',
    studentName: 'John Deo',
    email: 'johndeo@gmail.com',
    number: '1234567890',
    studentDes:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
  },
  {
    id: '4',
    tutorFirstName: 'Esther',
    bio: 'Est leo posuere turpis, quis bibendum nisi magna',
    tutorLastName: 'H',
    tutorProgfileImg: '/images/offerings/esther.png',
    imgUrl: '/images/offerings/session3.png',
    location: 'Location 3',
    title: 'Geometry',
    totalEnrolls: 1351,
    instruction:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
    tags: ['In-Person Individual Session'],
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
    price: 200,
    time: '1 Hour',
    isReviewing: false,
    bookingForm: 'BookingForm 1',
    studentName: 'John Deo',
    email: 'johndeo@gmail.com',
    number: '1234567890',
    studentDes:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
  },
  {
    id: '5',
    tutorFirstName: 'Esther',
    bio: 'Est leo posuere turpis, quis bibendum nisi magna',
    tutorLastName: 'H',
    tutorProgfileImg: '/images/offerings/esther.png',
    imgUrl: '/images/offerings/session3.png',
    location: 'Location 3',
    title: 'Geometry',
    totalEnrolls: 1351,
    instruction:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
    tags: ['In-Person Individual Session'],
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
    price: 200,
    time: '1 Hour',
    isReviewing: false,
    bookingForm: 'BookingForm 1',
    studentName: 'John Deo',
    email: 'johndeo@gmail.com',
    number: '1234567890',
    studentDes:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
  },
  {
    id: '6',
    tutorFirstName: 'Savannah',
    bio: 'Est leo posuere turpis, quis bibendum nisi magna',
    tutorLastName: 'N',
    tutorProgfileImg: '/images/offerings/savannah.png',
    imgUrl: '/images/offerings/session1.png',
    location: 'Location 4',
    title: 'Integration',
    totalEnrolls: 145,
    instruction:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
    tags: ['In-Person Individual Session'],
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
    price: 300,
    time: '1 Hour',
    isReviewing: false,
    bookingForm: 'BookingForm 1',
    studentName: 'John Deo',
    email: 'johndeo@gmail.com',
    number: '1234567890',
    studentDes:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
  },
  {
    id: '7',
    tutorFirstName: 'Eleanor',
    bio: 'Est leo posuere turpis, quis bibendum nisi magna',
    tutorLastName: 'P',
    tutorProgfileImg: '/images/offerings/eleanor.png',
    imgUrl: '/images/offerings/offerDetails.png',
    location: 'Location 2',
    title: 'Equations',
    totalEnrolls: 1028,
    instruction:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
    tags: ['Virtual Group Session'],
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
    price: 75,
    time: '1 Hour',
    isReviewing: false,
    bookingForm: 'BookingForm 1',
    studentName: 'John Deo',
    email: 'johndeo@gmail.com',
    number: '1234567890',
    studentDes:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
  },
  {
    id: '8',
    tutorFirstName: 'Jenny',
    bio: 'Est leo posuere turpis, quis bibendum nisi magna',
    tutorLastName: 'W',
    tutorProgfileImg: '/images/offerings/jenny.png',
    imgUrl: '/images/offerings/session2.png',
    location: 'Location 1',
    title: 'Introduction to Trignometry',
    totalEnrolls: 1245,
    instruction:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
    tags: ['Virtual Individual Session'],
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
    price: 100,
    time: '1 Hour',
    isReviewing: true,
    bookingForm: 'BookingForm 1',
    studentName: 'John Deo',
    email: 'johndeo@gmail.com',
    number: '1234567890',
    studentDes:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam elit id lectus bibendum, et fermentum risus mollis.',
  },
];
